import React, { Component } from 'react'
import MUIDataTable from "mui-datatables";
import { IconButton, Button } from '@material-ui/core';
import Launch from '@material-ui/icons/Launch';
import Add from '@material-ui/icons/Add';



export default class CourseTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoaded: false
        }
    }

    onActionClick(el) {
        this.props.actionClick(el);
    }

    onButtonClick = (id) => {
        this.props.onButtonClick(id);
    }


    getStatus(status) {
        if (status === 1) {
            return 'Yes';
        } else {
            return 'No';
        }
    }


    render() {
        const columns = [
            {
                name: "#",
                options: {
                    filter: true,
                    sort: true,
                }
            },

            {
                name: "Account Heads",
                options: {
                    filter: true,
                    sort: true,
                }
            },
            {
                name: "",
                options: {
                    filter: false,
                    sort: false,
                    download: false
                }
            },
            {
                name: "Action",
                options: {
                    filter: false,
                    sort: false,
                    download: false
                }
            }
        ];

        const options = {
            filterType: 'checkbox',
            selectableRows: false,
            responsive: 'scroll',
            customToolbar: () => {
                return (
                    <IconButton
                        onClick={this.props.onAddClick}>
                    <Add />
                    </IconButton>
                )
            }
        };

        let data = [];
        let table_data = this.props.table_data;
        if (table_data.length > 0) {
            data = table_data.map((el, index) =>
                [index + 1, el.head_name,<Button size="small" type="button" color="primary" onClick={this.onButtonClick.bind(this, el)}><Launch /> Go to legder</Button> ,<Launch onClick={this.onActionClick.bind(this, el)} />]
            )
        } else {
            data = [];
        }

        return (
            <div>
                <MUIDataTable
                    title={"Account Heads"}
                    data={data}
                    columns={columns}
                    options={options}

                />
            </div>
        )


    }
}
